export default __webpack_public_path__ + "static/media/jquery.3b8ad1b8.svg";